import React from 'react';

/**
 * Orders page ICON SVG - sofa with 3 lines on the left
 */
function OrdersNavIcon() {
  return (
    <svg
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1347.2 629.5"
      className="c-icon-nav-orders"
    >
      <g>
        <g>
          <g>
            <path
              className="c-icon-nav-path"
              d="M1253.8,168.6v-33.3c0-68.7-55.9-124.6-124.6-124.6h-537c-68.7,0-124.6,55.9-124.6,124.6v33.3c-45.8,1-82.7,38.4-82.7,84.4v195c0,54.4,44.2,98.6,98.6,98.6h15.2V618h31.7v-71.4h35.9h588.9h35.7V618h31.7v-71.4h15.3c54.4,0,98.6-44.2,98.6-98.6V253C1336.6,207,1299.6,169.5,1253.8,168.6z M550.4,514.9h-66.9c-36.9,0-66.9-30-66.9-66.9V253c0-29.1,23.7-52.8,52.8-52.8h28.2c29.1,0,52.8,23.7,52.8,52.8V514.9z M582.2,395.2h557.2v119.7H582.2V395.2z M1139.4,253v110.5H582.2V253c0-46-37-83.5-82.8-84.4v-33.3c0-51.2,41.6-92.8,92.8-92.8h537c51.2,0,92.8,41.6,92.8,92.8v33.3C1176.3,169.6,1139.4,207,1139.4,253z M1304.9,448c0,36.9-30,66.9-66.9,66.9h-66.9V253c0-29.1,23.7-52.8,52.8-52.8h28.2c29.1,0,52.8,23.7,52.8,52.8L1304.9,448L1304.9,448z"
            />
            <path
              className="c-icon-nav-path"
              d="M1233.2,628.6h-52.9v-71.4H541v71.4h-52.9v-71.4h-4.6c-60.2,0-109.2-49-109.2-109.2V253c0-47.8,36.2-88,82.7-94.2v-23.6C457,60.7,517.6,0.1,592.2,0.1h537c74.5,0,135.1,60.6,135.1,135.1v23.5c46.5,6.1,82.8,46.4,82.8,94.2v195c0,60.2-49,109.2-109.2,109.2h-4.8V628.6z M1201.5,607.4h10.6v-71.4h25.9c48.5,0,88-39.5,88-88V253c0-39.9-32.5-73.1-72.5-73.8l-10.4-0.2v-43.7c0-62.8-51.1-114-114-114h-537c-62.8,0-114,51.1-114,114v43.7l-10.3,0.2c-39.9,0.8-72.3,34-72.3,73.8v195c0,48.5,39.5,88,88,88h25.8v71.4h10.6v-71.4h681.6V607.4z M1238,525.5h-77.5V253c0-34.9,28.4-63.4,63.4-63.4h28.2c34.9,0,63.4,28.4,63.4,63.4v195C1315.5,490.7,1280.7,525.5,1238,525.5z M1181.7,504.3h56.3c31.1,0,56.3-25.3,56.3-56.3V253c0-23.3-18.9-42.2-42.2-42.2h-28.2c-23.3,0-42.2,18.9-42.2,42.2V504.3z M561,525.5h-77.5c-42.7,0-77.5-34.7-77.5-77.5V253c0-34.9,28.4-63.4,63.3-63.4h28.2c34.9,0,63.3,28.4,63.3,63.4V525.5z M469.4,210.8c-23.3,0-42.2,18.9-42.2,42.2v195c0,31.1,25.3,56.3,56.3,56.3h56.3V253c0-23.3-18.9-42.2-42.2-42.2H469.4z M1149.9,525.5H571.6V384.7h578.4V525.5z M592.7,504.3h536.1v-98.5H592.7V504.3z M1149.9,374.1H571.6V253c0-39.9-32.5-73.1-72.5-73.8l-10.4-0.2v-43.7c0-57,46.4-103.4,103.4-103.4h537c57,0,103.4,46.4,103.4,103.4v43.7l-10.3,0.2c-39.9,0.9-72.3,34-72.3,73.8V374.1z M592.7,352.9h536.1V253c0-47.8,36.2-88,82.7-94.2v-23.6c0-45.4-36.9-82.3-82.3-82.3h-537c-45.4,0-82.3,36.9-82.3,82.3v23.5c46.5,6.1,82.8,46.3,82.8,94.2V352.9z"
            />
          </g>
        </g>
        <g>
          <path
            className="c-icon-nav-path pink"
            d="M275.8,132.5H29.1C13,132.5,0,119.5,0,103.4s13-29.1,29.1-29.1h246.7c16.1,0,29.1,13,29.1,29.1S291.9,132.5,275.8,132.5z"
          />
        </g>
        <g>
          <path
            className="c-icon-nav-path blue"
            d="M275.8,516.7H29.1C13,516.7,0,503.7,0,487.6s13-29.1,29.1-29.1h246.7c16.1,0,29.1,13,29.1,29.1S291.9,516.7,275.8,516.7z"
          />
        </g>
        <g>
          <path
            className="c-icon-nav-path yellow"
            d="M212.4,324.6H29.1C13,324.6,0,311.6,0,295.5c0-16.1,13-29.1,29.1-29.1h183.3c16.1,0,29.1,13,29.1,29.1C241.4,311.6,228.4,324.6,212.4,324.6z"
          />
        </g>
      </g>
    </svg>
  );
}

export default OrdersNavIcon;



// WEBPACK FOOTER //
// ./src/layout/graphics/NavIcons/OrdersNavIcon.js